import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#D8FFFF" d="M98.76 18.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m88.77 15.22 3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12z"
    />
    <path
      fill="#D8FFFF"
      d="M49.44 108.13a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      d="M20.7 71.16h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H6.56c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M76.3 88.35a5.44 5.44 0 0 1-5.4 4.81H38.26c-3 0-5.44-2.43-5.44-5.44V22.44c0-3 2.44-5.44 5.44-5.44H70.9c3 0 5.44 2.44 5.44 5.44v39.89"
    />
    <path
      fill="#0597A3"
      d="M66.82 80.04c1.99 0 3.6 1.61 3.6 3.6s-1.61 3.6-3.6 3.6-3.6-1.61-3.6-3.6 1.61-3.6 3.6-3.6M42.34 22.92c1.99 0 3.6 1.61 3.6 3.6s-1.61 3.6-3.6 3.6-3.6-1.61-3.6-3.6 1.61-3.6 3.6-3.6M54.58 67.32c6.76 0 12.24-5.48 12.24-12.24s-5.48-12.24-12.24-12.24-12.24 5.48-12.24 12.24 5.48 12.24 12.24 12.24"
    />
    <path
      fill="#D8FFFF"
      d="M95.38 82.28V63.24c0-7.25-13.78-15.01-19.04-19.04v18.13l-6.23-4.99a4.73 4.73 0 0 0-4.57-1.22c-1.63.44-2.9 1.71-3.34 3.34a4.74 4.74 0 0 0 1.22 4.57l12.82 14.46v9.07c0 4.28 6.12 11.04 6.12 11.04h23.9L95.38 82.3z"
    />
    <path
      fill="#00D8D8"
      d="m81.53 104.62 25.08-5.15a3.52 3.52 0 0 0 2.74-4.15 3.52 3.52 0 0 0-4.15-2.74l-25.08 5.15a3.52 3.52 0 0 0-2.74 4.15 3.52 3.52 0 0 0 4.15 2.74M83.34 68.1c-.35 0-.71-.12-.99-.38L70.09 56.85a1.503 1.503 0 0 1 1.99-2.25l12.26 10.87c.62.55.68 1.5.13 2.12-.3.33-.71.5-1.12.5zM24.59 104.32c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
  </svg>
);
const SvgEnrichedIconPurchaseBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconPurchaseBrand);
export default Memo;
